import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import KeywordForm from "../../components/keywords/keyword-form";
import KeywordsTable from "../../components/keywords/keywords-table";

const KeywordPage = () => {
  return (
    <>
      <Routes>
        <Route index element={<KeywordsTable />} />
        <Route path="new" element={<KeywordForm />} />
        <Route path=":id/edit" element={<KeywordForm />} />
        <Route path="*" element={<Navigate to="/dashboard/keywords" />} />
      </Routes>
      <Outlet />
    </>
  );
};
export default KeywordPage;
